import { THEME } from '@enmon/commons';
import { Space } from 'antd';
import type { FC } from 'react';
import { Tag } from './Tag';

const SCOPE_COLOR = THEME.color.core.blue.main[500];

interface TagsRowProps {
  items: { value: string; label?: string }[];
  scope?: string;
  onClose?: (key: string) => void;
}

export const TagsRow: FC<TagsRowProps> = ({ items, onClose, scope }) => (
  <Space size={[8, 8]} wrap>
    {scope ? <Tag color={SCOPE_COLOR}>{scope}</Tag> : null}
    {items.map(({ value, label }) =>
      onClose ? (
        <Tag key={value} onClick={() => onClose(value)}>
          {label ?? value}
        </Tag>
      ) : (
        <Tag key={value}>{label ?? value}</Tag>
      ),
    )}
  </Space>
);
